import React from 'react';
import * as C from "../componentsM/index"
import { Link } from 'react-router-dom';
import { Accordion } from "flowbite-react";

const PrimaryYearsProgram = () => {


    
    const content = new getContent()


    return (
        <>

            <C.Hero title={"INTERNATIONAL BACCALAUREATE PRIMARY YEARS PROGRAMME"}
                image={"/hero/10.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>

                    <figure className='mx-auto md:w-[30%]'>
                        <img src="./model3.jpg" alt="Primary Years Programme model" className='w-full h-full object-contain' />
                    </figure>

                    <h1 className="text-xl">
                        Primary Years Programme
                    </h1>

                    <p>The Primary Years Programme (PYP) is designed for students aged 3 to 12. It focuses on the development of the whole child as an inquirer, both in the classroom and in the world outside. It is a framework guided by six transdisciplinary themes of global significance, explored using knowledge and skills derived from six subjects areas, as well as interdisciplinary skills, with a powerful emphasis on inquiry. The PYP is flexible enough to accommodate the demands of most national or local curriculums and provides the best preparation for students to engage in the IB Middle Years Programme. It is a unique international programme of guidelines that encompass social, physical, emotional, and cultural needs in addition to academics.</p>

                    <p>The Primary Years Programme (PYP) emphasises internationalism and identifies what students from all cultures should learn in six subject areas: Language Arts, Social Studies, Mathematics, Science, ICT, Art and Personal, Social and Physical Education.</p>


                    <p>The central purpose of the Primary Years Programme is to develop the attributes and traits identified in the
                        <Link className='text-myBlue/60' to={"/not"} >IB Learner Profile.</Link> Students are taught to become; inquirers, thinkers, communicators, risk-takers, and to be knowledgeable, principled, caring, open-minded, balanced and reflective.</p>

                    <a className='text-myBlue/60' href="https://www.ibo.org/pyp/">http://www.ibo.org/pyp</a>

                    <p className='text-xs text-gray-500'>Following are the five essential elements in the IB</p>



                    <Accordion collapseAll className='border-0'>


                        {content.accordionData.map((v, i) => <Accordion.Panel key={i}>
                            <Accordion.Title>{v.year}</Accordion.Title>
                            <Accordion.Content className='bg-white'>
                                <ul className="mb-2 text-gray-500 dark:text-gray-400">
                                    {v.events.map(c => <li key={c}>{c}</li>)}
                                </ul>
                            </Accordion.Content>
                        </Accordion.Panel>)}


                    </Accordion>


                </div>


            </section>

        </>
    )
}

export default PrimaryYearsProgram





class getContent {

    accordionData = [
        {
            year: "2014",
            events: [
                "Revision of Vision, Mission, Objectives",
                "Obtain PYP authorisation",
                "Academic resource development",
                "Introduction of MYP: The Next Chapter",
                "Upgrade technology for MYP e-Assessments",
                "Feasibility study of offering IGCSE and MYP as two separate systems"
            ]
        },
        {
            year: "2015",
            events: [
                "Academic resource development",
                "Commence the process for DP evaluation",
                "Design of accountability for the shared Mission and Objectives",
                "Expansion and relocation of the High School campus",
                "Commence the process for MYP evaluation",
                "One laptop per child policy from PYP 4 to DP 2"
            ]
        },
        {
            year: "2016",
            events: [
                "Academic resource development",
                "MYP/DP evaluation visit",
                "Implementation of the plan for accountability of the shared Mission and Objectives",
                "Launch of MYP eAssessments"
            ]
        },
        {
            year: "2017",
            events: [
                "Academic resource development",
                "Commence the process for PYP evaluation"
            ]
        },
        {
            year: "2018",
            events: [
                "Academic resource development",
                "PYP evaluation visit"
            ]
        },
        {
            year: "2019",
            events: []
        }
    ];



}